// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"237":"c352bd52","296":"bb7482ce","437":"0a70146f","472":"9d8dccce","714":"a1fba361","777":"a3713123","930":"a29baecd","934":"9662b1b6","952":"2904d723"}[chunkId] + ".chunk.css";
};